(() => {
  if (new URLSearchParams(location.search).has('nl4_perf')) {
    const root = document.documentElement;
    try {
      new PerformanceObserver(list => {
        const last = list.getEntries().at(-1);
        root.dataset.nl4LcpMs = String(Math.round(last.startTime));
      }).observe({type:'largest-contentful-paint',buffered:true});
      let cls = 0;
      new PerformanceObserver(list => {
        for (const entry of list.getEntries()) if (!entry.hadRecentInput) cls += entry.value;
        root.dataset.nl4Cls = cls.toFixed(4);
      }).observe({type:'layout-shift',buffered:true});
      const measure = () => {
        const resources = performance.getEntriesByType('resource');
        root.dataset.nl4Resources = String(resources.length);
        root.dataset.nl4VariantRequests = String(resources.filter(entry => entry.name.includes('option_values=')).length);
        const fcp = performance.getEntriesByName('first-contentful-paint')[0];
        if (fcp) root.dataset.nl4FcpMs = String(Math.round(fcp.startTime));
      };
      addEventListener('load',() => {measure(); setTimeout(measure,3000);},{once:true});
      if (document.readyState === 'complete') measure();
    } catch {}
  }
})();
if (document.querySelector('search-form[data-preview-theme-id]:not([data-preview-theme-id=""])')) document.documentElement.classList.add('nl4-preview-mode');
document.addEventListener('focusin', event => {
  const item = event.target.closest('.site-nav.style--classic .has-submenu');
  const submenu = item?.querySelector(':scope > .normal-menu');
  if (submenu) {
    const rtl = document.documentElement.dir === 'rtl';
    submenu.style.left = `${rtl ? item.getBoundingClientRect().right : item.getBoundingClientRect().left}px`;
  }
});
document.addEventListener('keydown', event => {
  const item = event.target.closest('.site-nav.style--classic .has-submenu');
  if (!item) return;
  const trigger = item.querySelector(':scope > a');
  if (event.key === 'ArrowDown' && event.target === trigger) {
    event.preventDefault();
    item.classList.add('focus');
    item.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (item.classList.contains('focus')) item.querySelector('.submenu a')?.focus(); }, 120);
  } else if (event.key === 'Escape' && item.classList.contains('focus')) {
    event.preventDefault();
    item.classList.remove('focus');
    item.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  }
});


(() => {
  const draftId = document.querySelector('search-form[data-preview-theme-id]')?.dataset.previewThemeId;
  if (!draftId) return;
  const pinLocalization = form => {
    const input = form?.querySelector('input[name="return_to"]');
    if (!input) return;
    const url = new URL(input.value || location.href, location.origin);
    url.searchParams.set('preview_theme_id', draftId);
    input.value = url.pathname + url.search;
  };
  document.querySelectorAll('form[action*="/localization"]').forEach(pinLocalization);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/localization"]')) pinLocalization(event.target);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('button[name="language_code"],button[name="country_code"]')) pinLocalization(event.target.closest('form'));
  }, true);
})();
